import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | IT Employees Federation` : "IT Employees Federation | Voice. Rights. Welfare.";
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
};

export const PageHero = ({ eyebrow, title, subtitle, image = "/images/kozhikode-lake.jpg", testId }) => {
  usePageMeta(title, subtitle);
  return (
    <section className="relative overflow-hidden bg-navy text-white" data-testid={testId || "page-hero"}>
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/40" />
      <div className="absolute inset-0 grid-texture" />
      <div className="container-x relative py-16 md:py-24">
        <nav className="mb-6 flex items-center gap-1 text-xs text-slate-300" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white" data-testid="breadcrumb-home">Home</Link>
          <ChevronRight className="h-3 w-3" />
          <span className="text-emerald-300">{title}</span>
        </nav>
        {eyebrow && <span className="eyebrow text-emerald-300 before:bg-emerald-300">{eyebrow}</span>}
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base text-slate-300 md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
};

export const SectionHead = ({ eyebrow, title, text, center = false, light = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <span className={`eyebrow ${light ? "text-emerald-300 before:bg-emerald-300" : ""}`}>{eyebrow}</span>}
    <h2 className={`section-title mt-3 ${light ? "text-white" : ""}`}>{title}</h2>
    {text && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{text}</p>}
  </div>
);
